import { render, staticRenderFns } from "./AddPreferenciaPage.vue?vue&type=template&id=e52c56e2&"
import script from "./AddPreferenciaPage.vue?vue&type=script&lang=js&"
export * from "./AddPreferenciaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports